// Canonical entries are declared once and referenced under both the new
// service-prefixed code and the legacy flat alias, so the two keys can never drift.
const WEBHOOK_AUTH_FAILED = { message: "Webhook authentication failed", severity: "info", status: 401, service: "event" };
const WEBHOOK_DELIVERY_FAILED = { message: "Webhook delivery failed", severity: "error", status: 502, service: "event" };
const SCHEDULER_MISSED_RUN = { message: "Scheduler missed expected fire", severity: "warn", status: 500, service: "event" };
const SCHEDULER_BACKFILL_BLOCKED = { message: "Scheduler backfill blocked (manual ack required)", severity: "critical", status: 500, service: "event" };
const DLQ_REPLAY_FAILED = { message: "DLQ replay failed", severity: "error", status: 500, service: "event" };
// Public webhook ingest refusing a delivery when no route target can still run —
// every one is deleted, disabled, or absent (the three ways /execute refuses).
// `info`/404, not the unregistered fall-through of error/500: a customer deleting
// or switching off their workflow is not a service fault, and a 5xx classification
// here would feed the namespace-wide service-5xx-rate page as well as
// fastn_errors_total.
const ROUTE_TARGET_GONE = { message: "Trigger route target cannot run", severity: "info", status: 404, service: "event" };
// Public webhook ingest whose sender hung up before the body finished. 499 is
// the status the gateway's access line records for the same event; `info`,
// because a sender or a hop in front of us giving up is not an event-service fault.
const WEBHOOK_BODY_INCOMPLETE = { message: "Webhook body was not received in full", severity: "info", status: 499, service: "event" };
/** Event service codes. Canonical `EVT-*`; legacy flat names kept as aliases. */
export const EVENT_ERRORS = {
    "EVT-WEBHOOK-AUTH-FAILED": WEBHOOK_AUTH_FAILED,
    "EVT-WEBHOOK-DELIVERY-FAILED": WEBHOOK_DELIVERY_FAILED,
    "EVT-SCHEDULER-MISSED-RUN": SCHEDULER_MISSED_RUN,
    "EVT-SCHEDULER-BACKFILL-BLOCKED": SCHEDULER_BACKFILL_BLOCKED,
    "EVT-DLQ-REPLAY-FAILED": DLQ_REPLAY_FAILED,
    "EVT-ROUTE-TARGET-GONE": ROUTE_TARGET_GONE,
    "EVT-WEBHOOK-BODY-INCOMPLETE": WEBHOOK_BODY_INCOMPLETE,
    WEBHOOK_AUTH_FAILED,
    WEBHOOK_DELIVERY_FAILED,
    SCHEDULER_MISSED_RUN,
    SCHEDULER_BACKFILL_BLOCKED,
    DLQ_REPLAY_FAILED,
    ROUTE_TARGET_GONE,
    WEBHOOK_BODY_INCOMPLETE,
};
//# sourceMappingURL=event.js.map